import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import type { StaffReportResearchQuestion } from "@/api/staff_reports";

const ANSWER_MAX_LENGTH = 2000;

export function ResearchQuestionsPanel({
  questions,
  answerTexts,
  pending,
  error,
  onAnswerTextChange,
  onContinue,
}: {
  questions: StaffReportResearchQuestion[];
  answerTexts: Record<number, string>;
  pending: boolean;
  error: string | null;
  onAnswerTextChange: (index: number, value: string) => void;
  onContinue: () => void;
}) {
  return (
    <div className="space-y-3 rounded-md border px-3 py-4 text-sm">
      <p className="font-medium">Please answer the questions below to help Ordinal write a better report.</p>
      <p className="text-xs text-muted-foreground">
        Answer what you can, or continue with blanks. You can skip every question.
      </p>
      {questions.map((question, index) => (
        <div key={`${question.question}-${index}`} className="space-y-1">
          <Label htmlFor={`research-answer-${index}`}>{question.question}</Label>
          {question.reason ? (
            <p className="text-xs italic text-muted-foreground">{question.reason}</p>
          ) : null}
          <Textarea
            id={`research-answer-${index}`}
            rows={2}
            maxLength={ANSWER_MAX_LENGTH}
            value={answerTexts[index] ?? ""}
            onChange={(event) => onAnswerTextChange(index, event.target.value)}
          />
          {(answerTexts[index] ?? "").length >= ANSWER_MAX_LENGTH ? (
            <p className="text-xs text-muted-foreground">
              Answers are limited to {ANSWER_MAX_LENGTH.toLocaleString()} characters, and anything longer was trimmed.
            </p>
          ) : null}
        </div>
      ))}
      {error ? (
        <p className="text-destructive" role="alert">{error}</p>
      ) : null}
      <Button disabled={pending} onClick={onContinue}>
        {pending ? "Saving…" : "Continue"}
      </Button>
    </div>
  );
}
